import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  facebookIcon,
  googleIcon,
  coachSignupCover,
  logo,
  starIcon,
  StarIconRed,
  ArrowUpRightBlue,
} from "../../constant/imagePath";
import { Button } from "../../stories/Button/Button";
import classes from "./SocialSignupCoachPage.module.css";
import { BeforeLoginHeader } from "../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { useHistory } from "react-router-dom";
import { MobileHeader } from "../../stories/MobileHeader/MobileHeader";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";
import { LinkButtonWithIcon } from "../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import Fonts from "../../stories/assets/Fonts";
import Colors from "../../stories/assets/Colors";
import {
  FacebookAuthProvider,
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { apiHeader, BaseURL } from "../../Config/apiUrl";
import { Post } from "../../Axios/AxiosFunctions";
import { toast } from "react-toastify";
import { falsyArray } from "../../util/CustomFunctions";

const SocialSignupCoachPage = (props) => {
  const history = useHistory();
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(false);
  const signupUrl = BaseURL("coach/signup");

  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, [window.innerWidth]);

  // Social Google Signup
  const HandleGoogleSignup = async () => {
    let provider = new GoogleAuthProvider();
    const auth = getAuth();

    signInWithPopup(auth, provider)
      .then(async (result) => {
        let user = result.user;
        const customClaim = await user.getIdTokenResult();
        const role = customClaim?.claims?.role;
        const params = {
          fullName: user?.displayName,
          email: user?.email,
          profilePicture: user?.photoURL,
          ...(falsyArray.includes(user?.phoneNumber) === false && {
            phoneNumber: user?.phoneNumber,
          }),
        };
        if (role === "student") {
          toast.error(
            "This Email is used by a Student. Please use another Email."
          );
          return;
        }
        if (role === "coach-pending") {
          history.push({
            pathname: `/coach-setup-profile`,
          });
        } else {
          HandleSubmitBackendApi(params, "Google");
        }
      })
      .catch((error) => {
        toast.error(`Error While Google Signup`);
      });
  };

  // Social Facebook Signup
  const HandleFacebookSignup = async () => {
    let provider = new FacebookAuthProvider();
    provider.setCustomParameters({ prompt: "select_account" });
    provider.addScope("user_birthday");
    provider.setCustomParameters({
      display: "popup",
    });
    const auth = getAuth();

    signInWithPopup(auth, provider)
      .then(async (result) => {
        let user = result.user;
        const customClaim = await user.getIdTokenResult();
        const role = customClaim?.claims?.role;
        const params = {
          fullName: user?.displayName,
          email: user?.email,
          profilePicture: user?.photoURL,
          ...(falsyArray.includes(user?.phoneNumber) === false && {
            phoneNumber: user?.phoneNumber,
          }),
        };
        if (role === "student") {
          toast.error(
            "This Email is used by a Student. Please use another Email."
          );
          return;
        }
        if (role === "coach-pending") {
          history.push({
            pathname: `/coach-setup-profile`,
          });
        } else {
          HandleSubmitBackendApi(params, "Facebook");
        }
      })
      .catch((error) => {
        // console.log(error);
        toast.error(`Error While Facbook Signup`);
      });
  };

  // Submit Backend Api
  const HandleSubmitBackendApi = async (params, provider) => {
    setLoading(true);
    const Header = await apiHeader(false);
    const response = await Post(signupUrl, params, Header);
    setLoading(false);
    if (response !== undefined) {
      toast.success(`${provider} Signup Successful`);
      history.push({
        pathname: `/coach-setup-profile`,
      });
    }
  };

  return (
    <>
      <div className={classes.SocialSignupCoachPage}>
        <div className={`container-fluid ${classes.container}`}>
          {isMobile ? (
            <MobileHeader
              isLogo={true}
              isAvatar={false}
              customStyle={{ padding: "16px 0px 0px 16px " }}
            />
          ) : (
            <BeforeLoginHeader
              onClick={() => {
                history.push({
                  pathname: "welcome",
                });
              }}
              icon={logo}
              text1={"Already have an account?"}
              text2={"Log In"}
              text1Style={{ color: Colors.neutralShadesOfDimGray }}
              goBackOnClick={() => history.goBack()}
            />
          )}

          <div className="row" style={{ height: "100%" }}>
            <div className="col-md-12">
              <div className="row">
                <div
                  className={`p-0 col-md-6 ${[
                    classes.imageContainer,
                    classes.innerContainer,
                  ].join(" ")}`}
                >
                  <img className="img-fluid d-block" src={coachSignupCover} />
                </div>
                <div
                  className={`p-5 col-md-6 ${[
                    classes.innerContainer,
                    classes.rightContainer,
                  ].join(" ")}`}
                >
                  <img
                    className={`img-fluid ${[classes.headingIcon].join(" ")}`}
                    src={isMobile ? StarIconRed : starIcon}
                  />
                  <span
                    className={`${[classes.headingText].join(" ")}`}
                    style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
                  >
                    I'm Coach
                  </span>

                  <Button
                    primary={false}
                    disabled={loading ? true : false}
                    size={"Large"}
                    label={"Sign in with Facebook"}
                    icon={facebookIcon}
                    onClick={() => {
                      HandleFacebookSignup();
                    }}
                  />
                  <div className="mb-3" />
                  <Button
                    primary={false}
                    disabled={loading ? true : false}
                    size={"Large"}
                    label={"Sign in with Google"}
                    icon={googleIcon}
                    onClick={() => {
                      HandleGoogleSignup();
                    }}
                  />
                  {/* Or Separator */}
                  <div className={`${[classes.separatorContainer].join(" ")} `}>
                    <div className={`${[classes.Separator].join(" ")}`} />
                    <div className={`${[classes.orSpan].join(" ")}`}>or</div>
                    <div className={`${[classes.Separator].join(" ")}`} />
                  </div>

                  <Button
                    primary={false}
                    disabled={false}
                    size={"Large"}
                    label={"Sign Up with Email"}
                    onClick={() => {
                      history.push({
                        pathname: "signupCoach",
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            {/* Footer */}
            <div className={`col-sm-12 ${classes.footerContainer}`}>
              {/* Already have account Login for mobile  */}
              <div className={classes.alreadyHaveAccountForMobile}>
                <p
                  style={{
                    ...Fonts.p2,
                    color: Colors.neutralShadesOfDimGray,
                  }}
                >
                  Already have an account?
                </p>
                <LinkButtonWithIcon
                  primary={true}
                  text={"Log in"}
                  rightIcon={ArrowUpRightBlue}
                  iconStyle={{ margin: "0px" }}
                  onClick={() => history.push("/login")}
                />
              </div>
            </div>
            {/*  */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SocialSignupCoachPage;
